// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202606041403/js/" + chunkId + "." + {"44":"99e2b959","225":"d2dffcde","481":"bd6b27db","486":"1f36fcf6","770":"e04d42b1"}[chunkId] + ".0.7795852001968772.chunk.js";
};